/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DraftFinalReportEmailRequest = {
  model_filename: string;
  report_filename: string;
  contact_name?: string | null;
  contact_email?: string | null;
  subject_template?: string | null;
  introduction_template?: string | null;
  use_llm?: boolean;
  voice?: DraftFinalReportEmailRequest.voice | null;
  current_subject?: string | null;
  current_body?: string | null;
};
export namespace DraftFinalReportEmailRequest {
  export enum voice {
    CONCISE = 'concise',
    FRIENDLY = 'friendly',
    PROFESSIONAL = 'professional',
  }
}
